// extracted by mini-css-extract-plugin
export default {"svg":"ExpandButton_svg__gIIee","buttonContainer":"ExpandButton_buttonContainer__OKz6s"};